// prop-types
import PropTypes from "prop-types";

function AdditionalProductPerformanceTable({ analysisData = [], minHeight = 0, isTop2BoxValuesShown = false, column2 = [] }) {
    let noOfProducts = analysisData.length;

    const checkOtherProductsNA = (data, backendVariable) => {
        let noOfProducts = data.length;
        let productsScoreWithNA = 0;
        data.map((datum) => {
            const _score = datum.scores.filter((ele) => ele.backendVariable === backendVariable);
            if (isTop2BoxValuesShown && (!_score[0] || !_score[0].agr_per)) {
                productsScoreWithNA += 1;
            }
            else if (!isTop2BoxValuesShown && (!_score[0] || !_score[0].mean)) {
                productsScoreWithNA += 1;
            }
        });
        if (productsScoreWithNA < noOfProducts) {
            return false;
        } else {
            return true;
        }
    };

    const column2Updated = column2
        .map((cols) => {
            if (!checkOtherProductsNA(analysisData, cols.backendVariable)) {
                return cols;
            }
        })
        .filter((col) => col);

    const hasData = analysisData.some((item) => item.scores && item.scores.length > 0);

    const hasValidColumns = column2Updated.length > 0;

    const renderTableHead = () => {
        return (
            <tr>
                <th
                    style={{
                        minWidth: 200,
                        maxWidth: 200,
                        position: "sticky",
                        left: "0",
                        outline: "1px solid #dee2e6",
                        zIndex: 2,
                    }}
                >
                    <p></p>
                </th>

                {analysisData &&
                    analysisData.map((datum, index) => {
                        return (
                            <th
                                key={index}
                                align="center"
                                className="text-xs color-blue"
                                style={{
                                    fontWeight: "600",
                                    padding: "6px 15px",
                                    minWidth: 200,
                                    maxWidth: 300,
                                    verticalAlign: "top",
                                }}
                            >
                                <span onClick={() => {}}>
                                    {datum?.title} / {datum?.study_reference_title}
                                </span>
                            </th>
                        );
                    })}
            </tr>
        );
    };

    const renderTableBody = () => {
        if (!hasData || !hasValidColumns) {
            return null;
        }

        const _row = column2Updated?.map((col, i) => {
            let productsScoreWithNA = 0;
            const _products = analysisData.map((datum, index) => {
                const _score = datum.scores.filter((ele) => ele.backendVariable === col.backendVariable);
                let value = "NA";
                if (isTop2BoxValuesShown) {
                    value = _score?.[0]?.agr_per ? parseFloat(_score?.[0].agr_per).toFixed(2) + " %" : "NA";
                } else {
                    value = _score?.[0] && _score?.[0].mean ? Number(_score?.[0].mean).toFixed(2) : "NA";
                }
                return (
                    <td
                        className="text-xs"
                        style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                        }}
                        key={index}
                    >
                        <span
                            style={{
                                marginRight: "10px",
                            }}
                        >
                            {value}
                        </span>
                    </td>
                );
            });

            const __row = (
                <tr key={i}>
                    <td
                        className="text-xs"
                        style={{
                            left: 0,
                            position: "sticky",
                            outline: "1px solid #dee2e6",
                            fontWeight: 500,
                            zIndex: 2,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        {/* <span>{col.displayLabel.charAt(0).toUpperCase() + col.displayLabel.slice(1)}</span> */}
                        <span style={{ textAlign: "left" }}>{col.displayLabel.charAt(0).toUpperCase() + col.displayLabel.slice(1) || col.backendVariable}</span>
                    </td>
                    {_products}
                </tr>
            );
            if (productsScoreWithNA < noOfProducts) {
                productsScoreWithNA = 0;
                return __row;
            } else {
                return;
            }
        });
        return _row;
    };

    return (
        <div
            className="table-responsive"
            style={{
                position: "relative",
                minHeight: minHeight,
                top: 10,
                width: "100%",
            }}
        >
            <table
                className="table table-bordered text-sm"
                style={{
                    background: "transparent",
                }}
            >
                <thead>{renderTableHead()}</thead>
                <tbody>{renderTableBody()}</tbody>
            </table>

            {(!hasData || !hasValidColumns) && (
                <div
                    style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#6c757d",
                        fontSize: "14px",
                        marginTop: "80px",
                        height: "100px",
                    }}
                >
                    No Data Available
                </div>
            )}
        </div>
    );
}

AdditionalProductPerformanceTable.propTypes = {
    analysisData: PropTypes.array,
    minHeight: PropTypes.string,
    isTop2BoxValuesShown: PropTypes.bool,
    column2: PropTypes.array,
};

export default AdditionalProductPerformanceTable;
